import {
  BrowserRouter,
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import Dashboard from "./components/Dashboard/Dashboard";
import Login from "./components/Login";
import Register from "./components/Register";
import PassengersList from "./components/Passengers/PassengersList";

import DriversList from "./components/Drivers/DriversList";
import ActiveDriversList from "./components/Drivers/ActiveDriversList";
import VehiclesList from "./components/Vehicles/VehiclesList";
import ViewDriver from "./components/Drivers/ViewDriver";
import WithNav from "./components/WithNav";
import WithoutNav from "./components/WithoutNav";
import ViewPassenger from "./components/Passengers/ViewPassenger";
import ReservationList from "./components/Trip/reservationsList";
import ActiveTripsList from "./components/Trip/ActiveTripsList";
import AcceptedTripsList from "./components/Trip/AcceptedTripsList";
import TripRequestDetail from "./components/Trip/TripRequestDetail";
import SharedTripsList from "./components/Trip/SharedTripsList";
import TripsList from "./components/Trip/TripsList";
import CompanyTripsList from "./components/Trip/CompanyTripsList";
import CompanyActiveTripsList from "./components/Trip/CompanyActiveTripsList";
import AddReservation from "./components/Trip/addReservation";
import ViewReservation from "./components/Trip/viewReservation";
import ViewVechicle from "./components/Vehicles/ViewVechicle";
import VehicleTypeList from "./components/VehicleType/VehicleTypeList";
import AddUser from "./components/users/AddUser";
import ListUser from "./components/users/ListUsers";
import EditUser from "./components/users/EditUser";
import ViewUser from "./components/users/ViewUser";
import RoleList from "./components/Role/List";
import PermissionList from "./components/Permissions/ListPermissions";
import TripDetail from "./components/Trip/TripDetail";
import SharedTripDetail from "./components/Trip/SharedTripDetail";
import DriversMap from "./components/Drivers/DriversMap";
import TransactionsList from "./components/Accounting/TransactionsList";
import DeletedTripsList from "./components/Accounting/DeletedTripsList";
import CreditsList from "./components/Accounting/CreditsList";
import RevenuesList from "./components/Accounting/RevenuesList";
import { UserContext } from "./components/UserContext";
import { RoleContext } from "./components/RoleContext";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import BroadcastMessage from "./components/VehicleType/BroadcastMessage";
import React, { useEffect, useState } from "react";
import { io } from "socket.io-client";
import Dispatch from "./components/VehicleType/Dispatch";
import Agent from "./components/VehicleType/Agent";
import SubAgent from "./components/VehicleType/SubAgent/SubAgent";
import DriversListByPromocode from "./components/Drivers/DriverListByPromocode";
import RegisterDriver from "./components/RegisterDriver/RegisterDriver";
import AmbulanceLookup from "./components/Ambulance/Lookup";
import HospitalDetail from "./components/Ambulance/Lookup/HospitalDetail";
import SpecialityDetail from "./components/Ambulance/Lookup/SpecialityDetail";

import SubAgentRegisteredDrivers from "./components/Drivers/SubAgentRegisteredDrivers";
import { FrontPage } from "./components/FrontPage";
import DashboardAgent from "./components/Dashboard/DashboardAgent";
import RegisterSubAgent from "./components/RegisterDriver/RegisterSubAgent";
import Corporate from "./components/Corporate/Corporate";
import ViewCompany from "./components/Corporate/ViewCompany";
import CorporateTransactions from "./components/Accounting/CorporateTransactions";
import PasswordResetForm from "./components/PasswordResetForm";
import ChangePassword from "./components/ChangePassword";
import Report from "./components/Report/Report";
import QuestionDetail from "./components/Ambulance/Lookup/QuestionDetail";
import AmbulanceOrRidePage from "./components/Ambulance/AmbulanceOrRidePage";
import AmbulanceFlow from "./components/Ambulance/AmbulanceFlow";
import HomeCareFlow from "./components/Ambulance/HomeCareFlow";
import PatientList from "./components/Ambulance/PatientList";
import ViewPatient from "./components/Ambulance/ViewPatient";
import "./App.css";
import AuthWrapper from "./AuthWrapper";
import Profile from "./components/Profile";
import ChangeProfile from "./components/ChangeProfile";
import ViewRole from "./components/Role/View";
import ResetPassword from "./components/ForgotPassword";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import Layout from './components/Layout';
import ConfigurationManagement from './pages/ConfigurationManagement';
import DistancePricing from './pages/Admin/DistancePricing';
import ApproachDistanceConfig from './pages/Admin/ApproachDistanceConfig';
import LiveEmergencyTracking from './components/LiveEmergencyTracking/LiveEmergencyTracking';
import { DashboardAmbulanceComapny } from "./components/Dashboard/DashboardForAmbulanceComapny.js";
import PassengerLogin from "./components/Passenger/PassengerLogin";
import PassengerSignup from "./components/Passenger/PassengerSignup";
import PassengerVerifyEmail from "./components/Passenger/PassengerVerifyEmail";
import PassengerProtectedRoute from "./components/Passenger/PassengerProtectedRoute";
import PassengerLayout from "./components/Passenger/PassengerLayout";
import PassengerHome from "./components/Passenger/PassengerHome";
import PassengerRide from "./components/Passenger/PassengerRide";
import PassengerTrips from "./components/Passenger/PassengerTrips";
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
const socket = io(process.env.REACT_APP_BASE_URL);

let dispatcher_socket = io("https://dispatch.leambulance.com");
// let dispatcher_socket = io("http://localhost:3000");
// let dispatcher_socket = io("http://196.188.235.241:3000");

function App() {
  const user = localStorage.getItem("userData");
  const roles = localStorage.getItem("roleData");
  // JSX code for your component
  useEffect(() => {
    dispatcher_socket.on("message", (data) => {
      // console.log("========incoming message=====", data);
    });
    // dispatcher_socket.on("estimatedPrice", (data) => {
    //   console.log("==========Here comes the socket data======", data);
    // });
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <UserContext.Provider value={user}>
        <RoleContext.Provider value={roles}>
          <BrowserRouter>
            <AuthWrapper>
              <Layout>
                <Routes>
                  <Route element={<WithoutNav />}>
                    <Route path="/passenger/login" element={<PassengerLogin />} />
                    <Route path="/passenger/signup" element={<PassengerSignup />} />
                    <Route path="/passenger/verify-email" element={<PassengerVerifyEmail />} />
                  </Route>

                  <Route element={<PassengerProtectedRoute />}>
                    <Route element={<PassengerLayout />}>
                      <Route path="/passenger" element={<PassengerHome />} />
                      <Route path="/passenger/ride" element={<PassengerRide socket={dispatcher_socket} />} />
                      <Route path="/passenger/emergency" element={<AmbulanceFlow socket={dispatcher_socket} />} />
                      {/* <Route path="/passenger/homecare" element={<HomeCareFlow socket={dispatcher_socket} />} /> */}{/* temporarily disabled */}
                      <Route path="/passenger/trips" element={<PassengerTrips />} />
                    </Route>
                  </Route>

                  <Route element={<WithoutNav />}>
                    <Route path="/" element={<Login />} />
                    <Route
                      path="/passwordResetAgent"
                      element={<PasswordResetForm role="agent" />}
                    />


                    <Route
                      path="/passwordResetSubAgent"
                      element={<PasswordResetForm role="subAgent" />}
                    />
                    <Route
                      path="/passwordResetAdmin"
                      element={<PasswordResetForm role="admin" />}
                    />
                    <Route path="/reset-password" element={<ResetPassword />} />


                    <Route
                      path="/admin"
                      element={
                        <Login url={"/login"} role={"admin"} link={"/dashboard"} />
                      }
                    />
                    <Route
                      path="/agentLogin"
                      element={
                        <Login
                          url={"/loginAgent"}
                          role={"agent"}
                          link={"/dashboardAgent"}
                        />
                      }
                    />
                    <Route
                      path="/subAgentLogin"
                      element={
                        <Login
                          url={"/loginSubAgent"}
                          role={"subAgent"}
                          link={"/dashboardSubAgent"}
                        />
                      }
                    />
                    <Route path="/register" element={<Register />} />
                    <Route path="/ambulance-company/register" element={React.createElement(require('./pages/AmbulanceCompanyRegistration.jsx').default)} />
                    <Route path="/terms" element={React.createElement(require('./pages/Terms.jsx').default)} />
                  </Route>

                  <Route element={<WithNav />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/liveTracking" element={<LiveEmergencyTracking socket={dispatcher_socket} />} />
                    <Route
                      path="/dashboardAgent"
                      element={<DashboardAgent role="agent" />}
                    />
                    <Route
                      path="/dashboardSubAgent"
                      element={<DashboardAgent role="subAgent" />}
                    />
                    <Route
                      path="/dashboardForAmbulanceComapny"
                      element={<DashboardAmbulanceComapny />}
                    />

                    <Route path="/changePassword" element={<ChangePassword />} />
                    <Route path="/profile" element={<Profile />} />

                    <Route path="/report" element={<Report />} />
                    <Route path="/patients" element={<PatientList />} />
                    <Route path="/passengers" element={<PassengersList />} />
                    <Route path="/vehicles" element={<Register />} />
                    <Route path="/viewDriver/:id" element={<ViewDriver />} />
                    <Route path="/viewPassenger/:id" element={<ViewPassenger />} />
                    <Route path="/viewPatient/:id" element={<ViewPatient />} />
                    <Route path="/drivers" element={<DriversList />} />
                    <Route path="/corporateAccount" element={<Corporate />} />
                    <Route path="/viewCompany/:id" element={<ViewCompany />} />

                    <Route
                      path="/driversByPromocode"
                      element={<DriversListByPromocode />}
                    />
                    <Route path="/driversMap" element={<DriversMap />} />
                    <Route path="/activeDrivers" element={<ActiveDriversList />} />
                    <Route path="/vehicles" element={<VehiclesList />} />
                    <Route path="/vehicleList" element={<VehiclesList />} />
                    <Route path="/activeTrips" element={<ActiveTripsList socket={dispatcher_socket} />} />
                    <Route path="/acceptedTrips" element={<AcceptedTripsList socket={dispatcher_socket} />} />
                    <Route path="/tripRequestDetail/:id" element={<TripRequestDetail socket={dispatcher_socket} />} />
                    <Route path="/companyActiveTrips" element={<CompanyActiveTripsList />} />
                    <Route path="/sharedTrips" element={<SharedTripsList />} />
                    <Route path="/trips" element={<TripsList />} />
                    <Route path="/companyTrips" element={<CompanyTripsList />} />
                    <Route path="/reservations" element={<ReservationList />} />
                    <Route path="/addReservation" element={<AddReservation />} />
                    <Route path="/reservation/:id" element={<ViewReservation />} />
                    <Route path="/tripDetail/:id" element={<TripDetail />} />
                    <Route
                      path="/sharedTripDetail/:id"
                      element={<SharedTripDetail />}
                    />
                    <Route path="/viewVehicle/:id" element={<ViewVechicle />} />
                    <Route path="/vehicleTypes" element={<VehicleTypeList />} />
                    <Route
                      path="/broadcastMessage"
                      element={<BroadcastMessage socket={socket} />}
                    />
                    {/* <Route
                      path="/dispatch"
                      element={<Dispatch socket={dispatcher_socket} />}
                    /> */}
                    <Route
                      path="/dispatch"
                      element={<AmbulanceOrRidePage socket={dispatcher_socket} />}
                    />
                    <Route path="/agent" element={<Agent />} />
                    <Route path="/sub-agent/:id" element={<SubAgent />} />

                    <Route path="/addUser" element={<AddUser />} />
                    <Route path="/users" element={<ListUser />} />
                    <Route path="/addUser" element={<AddUser />} />
                    <Route path="/user/:id" element={<EditUser />} />
                    <Route path="/viewUser/:id" element={<ViewUser />} />
                    <Route path="/roles" element={<RoleList />} />
                    <Route path="/viewRole/:id" element={<ViewRole />} />

                    <Route path="/permissions" element={<PermissionList />} />
                    <Route path="/transactionsList" element={<TransactionsList />} />
                    <Route path="/deletedTrips" element={<DeletedTripsList />} />

                    <Route path="/creditsList" element={<CreditsList />} />
                    <Route
                      path="/corporateTransactions"
                      element={<CorporateTransactions />}
                    />
                    <Route path="/companyTransactions" element={React.createElement(require('./components/Accounting/CompanyTransactionsList.js').default)} />

                    <Route
                      path="/addDriverAsAgent"
                      element={
                        <RegisterDriver registerer="agent" link="/dashboardAgent" />
                      }
                    />
                    <Route path="/addSubAgent" element={<RegisterSubAgent />} />

                    <Route
                      path="/addDriverAsSubAgent"
                      element={
                        <RegisterDriver
                          registerer="subAgent"
                          link="/dashboardSubAgent"
                        />
                      }
                    />

                    <Route
                      path="/driver-by-sub-agent/:id"
                      element={<SubAgentRegisteredDrivers />}
                    />

                    <Route path="/ambulance_lookup"
                      element={<AmbulanceLookup />}
                    />

                    <Route path="/hospital/:hospitalId" element={<HospitalDetail />} />
                    <Route path="/speciality/:specialtyId" element={<SpecialityDetail />} />

                    <Route path="/question/:questionId" element={<QuestionDetail />} />
                    <Route path="/configuration" element={<ConfigurationManagement />} />
                    <Route path="/distance-pricing" element={<DistancePricing />} />
                    <Route path="/approach-distance-config" element={<ApproachDistanceConfig />} />
                    {/* <Route path="/admin/pending-ambulance-companies" element={React.createElement(require('./pages/Admin/PendingAmbulanceCompanies.jsx').default)} /> */}
                  </Route>
                </Routes>
              </Layout>
            </AuthWrapper>
          </BrowserRouter>
        </RoleContext.Provider>
      </UserContext.Provider>
    </ThemeProvider>
  );
}


export default App;
